import { Injectable } from '@angular/core';
import { Toast } from '@shared/models';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastrService {
  get toasts$() {
    return this.toastsSubject$.asObservable();
  }

  private toastsSubject$: BehaviorSubject<Toast[]> = new BehaviorSubject([]);
  constructor() {}

  public success(message: string, timeout = 0, translateParams?: Record<string, string | number>): void {
    this.create('success', message, timeout, translateParams);
  }

  public error(message: string, timeout = 0, isUniq = false, translateParams?: Record<string, string | number>): void {
    const toasts = this.toastsSubject$.getValue();
    if (isUniq && toasts.find(t => t.message === message)) {
      return;
    }
    this.create('danger', message, timeout, translateParams);
  }

  public info(message: string, timeout = 0, translateParams?: Record<string, string | number>): void {
    this.create('info', message, timeout, translateParams);
  }

  public closed(id: number) {
    this.toastsSubject$.next(this.toastsSubject$.getValue().filter(i => i.id !== id));
  }

  private create(
    type: 'success' | 'danger' | 'info',
    message: string,
    timeout: number,
    translateParams?: Record<string, string | number>
  ) {
    const toasts = this.toastsSubject$.getValue();
    const toast: Toast = {
      type,
      message,
      dismissible: true,
      timeout,
      id: ((toasts.length && toasts[toasts.length - 1].id) || 0) + 1,
      translateParams
    };
    this.toastsSubject$.next([...toasts, toast]);
  }
}
